import type { ReactNode } from 'react'

export interface MetaRowProps {
  icon: ReactNode
  /** Uppercase label shown above the value. */
  label: string
  children: ReactNode
}

/** Icon + uppercase label + value row. Used in detail page sidebars. */
export function MetaRow({ icon, label, children }: MetaRowProps) {
  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
      <span style={{ color: 'var(--emerald-700)', marginTop: 1 }}>{icon}</span>
      <div>
        <div
          style={{
            fontSize: 12,
            color: 'var(--ink-3)',
            fontWeight: 700,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
          }}
        >
          {label}
        </div>
        <div style={{ fontSize: 15.5, color: 'var(--ink-1)', fontWeight: 500 }}>
          {children}
        </div>
      </div>
    </div>
  )
}
